import { Button, Popconfirm } from "antd";
import dayjs from "dayjs";
export function getDsrExpenseTableHeader() {
  return [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => a.category.localeCompare(b.category),
    },
    {
      title: "Description",
      dataIndex: "e_desc",
      key: "e_desc",
      sorter: (a, b) => a.e_desc.localeCompare(b.e_desc),
    },
    {
      title: "Voucher",
      dataIndex: "voucher",
      key: "voucher",
    },
    {
      title: "Created By",
      dataIndex: "addedby",
      key: "addedby",
      sorter: (a, b) => a.addedby.localeCompare(b.addedby),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Returned Amount",
      dataIndex: "ret_amt",
      key: "ret_amt",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    
  ];
}

